import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["device", "defaultViewportWidths", "deviceWidthRanges", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import DeviceScreenWidthMobileDetectProvider from './DeviceScreenWidthMobileDetectProvider.js';

var _React$createContext = React.createContext({}),
    Provider = _React$createContext.Provider,
    DeviceScreenWidthConsumer = _React$createContext.Consumer;

export var DEFAULT_SCREEN_WIDTHS = {
  phone: 640,
  tablet: 980,
  desktop: 1280
};
export var DEFAULT_DEVICE_SCREEN_WIDTH_RANGES = {
  phone: [0, 767.98],
  tablet: [768, 989.98],
  desktop: [990, null]
};

var DeviceScreenWidthProvider = function DeviceScreenWidthProvider(_ref) {
  var device = _ref.device,
      _ref$defaultViewportW = _ref.defaultViewportWidths,
      defaultViewportWidths = _ref$defaultViewportW === void 0 ? DEFAULT_SCREEN_WIDTHS : _ref$defaultViewportW,
      _ref$deviceWidthRange = _ref.deviceWidthRanges,
      deviceWidthRanges = _ref$deviceWidthRange === void 0 ? DEFAULT_DEVICE_SCREEN_WIDTH_RANGES : _ref$deviceWidthRange,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var width = device ? defaultViewportWidths[device] || defaultViewportWidths.desktop : undefined;
  var deviceWidth = typeof window !== 'undefined' ? window.innerWidth : width;
  var value = useMemo(function () {
    return {
      width: deviceWidth,
      initialWidth: width ? width : deviceWidth,
      deviceWidthRanges: deviceWidthRanges
    };
  }, [deviceWidth, deviceWidthRanges, width]);
  return React.createElement(Provider, _objectSpread({
    value: value
  }, props), children);
};

export { DeviceScreenWidthProvider, DeviceScreenWidthConsumer, Provider, DeviceScreenWidthMobileDetectProvider };